import {GenericLoader} from "@twigsby/frontend-framework";
import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import {useUKPBAuth} from "../Providers/AuthProvider";

type ProtectedRouteType = {
    blockSingleRoles?: Array<string>;
    children?: any;
}

const ProtectedRoute = (props: ProtectedRouteType) => {
    const { token, loginInProgress, loggingOut, LogIn } = useUKPBAuth();

    useEffect(() => {
        if (!token  && !loginInProgress && !loggingOut.current) {
            LogIn();
        }
    }, []);

    if(!token && loginInProgress) {
        return null;
    }

    return <Outlet />;
};

export default ProtectedRoute;
